import styled from "styled-components";

export const StyledInitialRenderScreen = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.colors.container.primary};
`;
